interface Strings {
  locationAssistiveLabel?: string,
}

export class GridDiagramCellConfig {
  public static defaultStrings: Strings = {}
}
